'use client';

import { CompletionProgress } from './CompletionProgress';

export function ReportTransition() {
  return <CompletionProgress stage="analyzing" />;
}
